import React from "react";
import { sessionPoints } from "../../data/content";
export function SessionSection() {
  return <section aria-labelledby="session-title" className="bg-navy" data-id="element-202" data-mp="3a4m9jpdibotn">
      <div className="container-x grid gap-10 py-14 sm:gap-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-203" data-mp="3a671d78fstnt">
        <div className="lg:col-span-5" data-id="element-204" data-mp="3k20gmydjj19a">
          <p className="eyebrow" data-id="element-205" data-mp="3k17fccxcp3yj">In the gym</p>
          <h2 id="session-title" className="section-title mt-4" data-id="element-206" data-mp="3k4d23liibtr3">
            Built around a <span className="text-cyan" data-id="element-207" data-mp="1uaxqwa3bdi7">real school session</span>
          </h2>
          <p className="mt-5 max-w-[30rem] text-[16px] leading-[1.7] text-ice/80 sm:mt-6 sm:text-[17px]" data-id="element-208" data-mp="3t25m32z6bpkt">
            Lessons are planned around the shape of an actual PE period: a defined length, the equipment schools typically have, and room for you to adapt.
          </p>

          <div className="mt-8 max-w-[30rem] sm:mt-10" data-id="element-209" data-mp="km3oek1osmmr">
            <h3 className="sr-only" data-id="element-210" data-mp="kkiu8vjab5pf">Lesson length</h3>
            <div data-id="element-211" data-mp="gml5tuxc8nn3">
              <div className="flex items-baseline justify-between text-sm" data-id="element-212" data-mp="gn4qhjedhq4t">
                <span className="font-bold uppercase tracking-[0.14em] text-ice/80" data-id="element-213" data-mp="20tv7q6fz81fx">Planned lesson</span>
                <span className="font-display text-2xl font-bold text-ice" data-id="element-214" data-mp="24uwxlwo07158">45 min</span>
              </div>
              <div className="mt-2 h-3 rounded-full bg-cyan" aria-hidden="true" data-id="element-215" data-mp="29rndaivwbuq4" />
            </div>
            <div className="mt-5" data-id="element-216" data-mp="2etw6ngcokysr">
              <div className="flex items-baseline justify-between text-sm" style={{
              width: "88.9%"
            }} data-id="element-217" data-mp="2jre7skkgi9q7">
                <span className="font-bold uppercase tracking-[0.14em] text-ice/80" data-id="element-218" data-mp="2nszraorhxm9d">Adaptation</span>
                <span className="font-display text-2xl font-bold text-ice" data-id="element-219" data-mp="2sjpzsav7y58a">40 min</span>
              </div>
              <div className="mt-2 h-3 rounded-full bg-white/10" aria-hidden="true" data-id="element-220" data-mp="2xijaxwn19k5a">
                <div className="h-full rounded-full bg-orange" style={{
                width: "88.9%"
              }} data-id="element-221" data-mp="32hvykjlqav8x" />
              </div>
            </div>
          </div>
        </div>

        <dl className="border-t-2 border-cyan lg:col-span-6 lg:col-start-7 lg:self-end" data-id="element-222" data-mp="37hia8olws3fm">
          {sessionPoints.map(point => <div key={point.title} className="border-b border-white/10 py-5 sm:py-7" data-id="element-223" data-mp="2hqi8bu174s5s">
              <dt className="font-display text-[22px] font-bold uppercase leading-none text-ice sm:text-[28px]" data-id="element-224" data-mp="2crnjaacmy7d8">{point.title}</dt>
              <dd className="mt-2 max-w-[36rem] text-[15px] leading-relaxed text-ice/75 sm:mt-3 sm:text-base" data-id="element-225" data-mp="2ms7m3hfszjxk">{point.text}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}